<!-- ═══════════════════════════════════════════════════════════════════════════
 FILE: src/app/shared/dialogs/cal-error-dialog/cal-error-dialog.component.html
 VERSION: v1.0.0 - Client Access License Error Dialog Template
 DATE: 2025-01-09
═══════════════════════════════════════════════════════════════════════════ -->

<div class="cal-dialog">
  
  <!-- ═══════════════════════════════════════════════════════════════════════
       HEADER
  ═══════════════════════════════════════════════════════════════════════ -->
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>{{ getIconName() }}</mat-icon>
    </div>
    <h2 mat-dialog-title>{{ getErrorTitle() }}</h2>
  </div>

  <!-- ═══════════════════════════════════════════════════════════════════════
       CONTENT
  ═══════════════════════════════════════════════════════════════════════ -->
  <mat-dialog-content class="dialog-content">
    
    <!-- Countdown Display -->
    <div class="countdown-section">
      <div class="countdown-circle">
        <div class="countdown-number">{{ countdown }}</div>
        <div class="countdown-label">seconds</div>
      </div>
      <div class="countdown-text">
        Redirecting to home page...
      </div>
    </div>

    <!-- Error Description -->
    <div class="description-section">
      <p class="description-text">
        {{ getErrorDescription() }}
      </p>
    </div>

    <!-- License Details (if available) -->
    <div class="info-box" *ngIf="data.hasLicense || data.assignedBy">
      <div class="info-icon">ℹ️</div>
      <div class="info-content">
        <p><strong>License Details:</strong></p>
        <ul>
          <li *ngIf="data.status !== 'no_license'">
            Status: <strong>{{ data.status | uppercase }}</strong>
          </li>
          <li *ngIf="data.expiresAt">
            Expired on: <strong>{{ getFormattedExpirationDate() }}</strong>
          </li>
          <li *ngIf="data.assignedBy">
            Assigned by: <strong>{{ data.assignedBy }}</strong>
          </li>
          <li *ngIf="data.assignedAt">
            Assigned on: <strong>{{ getFormattedAssignmentDate() }}</strong>
          </li>
        </ul>
      </div>
    </div>

    <!-- Contact Admin Box -->
    <div class="contact-box" *ngIf="hasAdminContact()">
      <div class="contact-icon">👤</div>
      <div class="contact-content">
        <p><strong>Need Help?</strong></p>
        <p>Contact your administrator to resolve this issue:</p>
        <button 
          mat-stroked-button 
          class="btn-contact"
          (click)="onContactAdmin()">
          <mat-icon>email</mat-icon>
          Contact {{ data.assignedBy }}
        </button>
      </div>
    </div>

  </mat-dialog-content>

  <!-- ═══════════════════════════════════════════════════════════════════════
       ACTIONS
  ═══════════════════════════════════════════════════════════════════════ -->
  <mat-dialog-actions class="dialog-actions">
    <button 
      mat-raised-button 
      color="primary" 
      class="btn-home" 
      (click)="onGoHomeNow()"
      aria-label="Go to home page now">
      <mat-icon>home</mat-icon>
      Go Home Now
    </button>
  </mat-dialog-actions>

</div>

<!-- ═══════════════════════════════════════════════════════════════════════════
 END OF FILE
═══════════════════════════════════════════════════════════════════════════ -->
